import script from "./Matrix.vue?vue&type=script&setup=true&lang=js"
export * from "./Matrix.vue?vue&type=script&setup=true&lang=js"

import "./Matrix.vue?vue&type=style&index=0&id=8668dd60&lang=scss&scoped=true"

import exportComponent from "/Users/oleksandrpolishchuk/Documents/dev/eye-test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8668dd60"]])

export default __exports__